import { FC } from 'react'
import dynamic from 'next/dynamic'
import { Row, Col, Breadcrumb, Text, Content } from '@/client/components'
import Page from '@/client/submodules/Page'
import SignupSuccessLottie from './Lottie/SignupSuccessLottie.json'
import * as S from './styles'
import { SignupSuccessProps } from './types'

// Load Lottie-Component only in case of client side rendering (exclude SSR)
const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

export const SignupSuccess: FC<SignupSuccessProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, title, subheading, info_text }
}) => (
  <Page seo={seo} header={header} footer={footer} noIndex={true}>
    <S.Content>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={7} xl={6}>
          <S.TextContainer>
            <Text size='h3' weight='bold' margin='0 0 0.5rem' itemProp='name' lineHeight='1.2'>
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </Text>
            <Text size='md' weight='bold' margin='1.5rem 0 0.5rem'>
              <span dangerouslySetInnerHTML={{ __html: subheading }} />
            </Text>
            <Content content={info_text} style={{ paddingTop: '1rem' }} />
          </S.TextContainer>
        </Col>
        <Col xs={12} lg={5} xl={6}>
          <div>
            <Lottie animationData={SignupSuccessLottie} loop={true} />
          </div>
        </Col>
      </Row>
    </S.Content>
  </Page>
)
